import React, { Suspense, useEffect, useRef } from 'react'
import { Skeleton } from 'antd'

import { APP } from '@/redux/actionTypes'
import { RootState } from '@/redux/store'
import { useAppDispatch, useAppSelector } from '@/utils/hooks'
import { trackEntityView } from '@/utils/pageTracking'

import LayoutFactory from '@/components/layout/LayoutFactory'

interface Props {
  routes: Routes
}

const Layout: React.FC<Props> = ({ routes, ...rest }) => {
  const dispatch = useAppDispatch()
  const { userInfo, currentEntity, entityIcon, uiConfig } = useAppSelector(
    (state: RootState) => state.app
  )
  const lastEntityIdRef = useRef<string | number>()

  useEffect(() => {
    if (!userInfo.userId) {
      queryUserInfo()
    }
  }, [userInfo])

  useEffect(() => {
    if (currentEntity.entityId) {
      queryEntityIcon()
      queryUserResources()
      queryBrandList()
      getUIConfig()

      // 实体切换埋点 - 只在实体ID变化时上报
      if (lastEntityIdRef.current && lastEntityIdRef.current !== currentEntity.entityId) {
        trackEntityView({ userInfo, currentEntity })
      }
      lastEntityIdRef.current = currentEntity.entityId
    }
  }, [currentEntity])

  useEffect(() => {
    if (entityIcon) {
      setLinkIcon(entityIcon)
    }
  }, [entityIcon])

  const queryBrandList = () => {
    dispatch({ type: APP.GET_ENTITY_BRANDLIST, payload: { entityId: currentEntity.entityId } })
  }

  const queryUserInfo = () => {
    dispatch({ type: APP.GET_USER_INFO })
  }

  const queryUserResources = () => {
    dispatch({ type: APP.GET_USER_RESOURCES, payload: { entityId: currentEntity.entityId } })
  }

  const queryEntityIcon = () => {
    dispatch({ type: APP.GET_ENTITY_ICON, payload: { entityId: currentEntity.entityId } })
  }

  const setLinkIcon = (url: string) => {
    if (url) {
      const link: any = document.getElementById('iconLink')
      link.href = url
      // if (!link.getAttribute('href')) {
      //   link.href = url
      // }
    }
  }

  const getUIConfig = () => {
    dispatch({ type: APP.GET_UI_CONFIG, payload: { entityId: currentEntity.entityId } })
  }

  return (
    <Suspense fallback={<Skeleton active />}>
      <LayoutFactory routes={routes} {...rest} />
    </Suspense>
  )
}

export default Layout
